module.exports = __webpack_public_path__ + "static/media/image2.8f845b2e.png";